// Every page that has to say a puzzle or a page is not there (CLAUDE.md: Game
// screens — the notice pages).
//
// **The same screen as a game, with a message where the board would be**: the
// row under the header — All games, the game's name with no number, How it
// works — then one centred line set exactly like the instruction line, then
// the result screen's purple buttons, so it is never a dead end. Used for a
// number that does not exist yet, a withdrawn puzzle, a game that has not
// started, a failed load, and any address that is not on the site.
//
// **The buttons go somewhere useful.** Play Call Sheet is the next one this
// device has not finished; the daily is today's, or — where today's is already
// finished — the most recent one this device has not finished, as on a result
// screen. On a Call Sheet page Call Sheet comes first; anywhere else, the
// daily. Where there is no such puzzle there is no button.
//
// **The end of the Call Sheet pool is a notice too**, with one more button
// first: a replay of the puzzle this device finished longest ago (`replay`).
import { GameHeader } from '../components/GameHeader.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { useNextPuzzle } from '../lib/next-puzzle.ts';
import type { GameKey } from '../lib/history.ts';
import '../components/result.css';
import './Notice.css';

const NAMES: Record<GameKey, string> = { 'running-order': 'Running Order', 'call-sheet': 'Call Sheet' };

export function Notice({ game, message }: { game?: GameKey; message: string }) {
  // Each game's own next puzzle for this device, or its countdown (lib/next-puzzle.ts).
  const sheet = useNextPuzzle('call-sheet');
  const daily = useNextPuzzle('running-order');
  const sheetButton = <NextButton game="call-sheet" next={sheet} key="sheet" />;
  const dailyButton = <NextButton game="running-order" next={daily} key="daily" />;
  const buttons = game === 'call-sheet' ? [sheetButton, dailyButton] : [dailyButton, sheetButton];

  return (
    <main className="column notice">
      <GameHeader game={game ? NAMES[game] : undefined} />
      <p className="panel-line notice-line">{message}</p>
      {(sheet?.pick || daily?.pick) && <div className="next-row">{buttons}</div>}
    </main>
  );
}
